import { render } from "./MultimediaVideos.vue?vue&type=template&id=1830eb48"
import script from "./MultimediaVideos.vue?vue&type=script&lang=js"
export * from "./MultimediaVideos.vue?vue&type=script&lang=js"

import "./MultimediaVideos.vue?vue&type=style&index=0&id=1830eb48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__